
import React from 'react';

export const FloatingButton: React.FC = () => {
  const scrollToConsentForm = () => {
    const element = document.getElementById('consent-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <button
      onClick={scrollToConsentForm}
      className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 z-40 whitespace-nowrap cursor-pointer"
    >
      <i className="ri-file-text-line mr-2"></i>
      동의서 작성
    </button>
  );
};
